import type { CSSProperties } from "react";

function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const cleaned = hex.replace("#", "").trim();
  if (cleaned.length === 3) {
    return {
      r: parseInt(cleaned[0] + cleaned[0], 16),
      g: parseInt(cleaned[1] + cleaned[1], 16),
      b: parseInt(cleaned[2] + cleaned[2], 16),
    };
  }
  if (cleaned.length === 6) {
    return {
      r: parseInt(cleaned.slice(0, 2), 16),
      g: parseInt(cleaned.slice(2, 4), 16),
      b: parseInt(cleaned.slice(4, 6), 16),
    };
  }
  return null;
}

function relativeLuminance(r: number, g: number, b: number): number {
  const [rs, gs, bs] = [r, g, b].map((c) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

/** Retorna preto para fundos claros e branco para fundos escuros/pretos. */
export function getContrastTextColor(backgroundColor: string): "#000000" | "#ffffff" {
  const rgb = hexToRgb(backgroundColor);
  if (!rgb) return "#000000";
  return relativeLuminance(rgb.r, rgb.g, rgb.b) > 0.5 ? "#000000" : "#ffffff";
}

/** Estilo inline para botão principal com a cor primária do cliente. */
export function getClientPrimaryButtonStyle(primaryColor: string): CSSProperties {
  return {
    backgroundColor: primaryColor,
    color: getContrastTextColor(primaryColor),
  };
}
